// extracted by mini-css-extract-plugin
export default {"main":"WhiteMainBackgroundWithHeading_main__u+XkB","heading":"WhiteMainBackgroundWithHeading_heading__zr0X+"};